module.exports = __webpack_public_path__ + "static/media/matt-wilson-logo-white.beb0ecc5.png";